import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { SITE } from "../../lib/content";
import { track } from "../../lib/quiz";

// Sticky bottom-right button that appears on conversion-critical pages.
// On mobile, sits above the 56px bottom nav.
const SHOW_ON = ["/nation-quiz", "/nations", "/mission", "/characters", "/pilot"];

export default function StickyJoin() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  // remember dismiss for this session
  useEffect(() => {
    const dismissed = sessionStorage.getItem("cbb-sticky-dismissed");
    if (dismissed === "1") setOpen(false);
    else setOpen(true);
  }, [pathname]);

  if (!SHOW_ON.includes(pathname)) return null;
  if (!open) return null;
  // Hide the CTA entirely if there's no valid Discord invite configured
  // (prevents an empty href="" that reloads the current page).
  const discordHref = SITE?.socials?.discord;
  if (!discordHref || !/^https?:\/\//i.test(discordHref)) return null;

  return (
    <div
      className="fixed right-4 md:right-6 z-50 bottom-[5.5rem] md:bottom-6"
      data-testid="sticky-join"
    >
      <div className="flex items-center gap-2">
        <a
          href={SITE.socials.discord}
          target="_blank"
          rel="noreferrer noopener"
          data-testid="sticky-join-discord"
          onClick={() => track("clicked_join_discord_sticky", { from: pathname })}
          className="inline-flex items-center gap-2 bg-[#C5A059] text-black px-5 py-3 text-xs tracking-[0.22em] uppercase shadow-[0_8px_32px_rgba(197,160,89,0.35)] hover:bg-[#D4AF68] transition-colors"
        >
          <Sparkles size={14} strokeWidth={2} />
          Join the Dream
        </a>
        <button
          type="button"
          aria-label="Dismiss"
          data-testid="sticky-join-close"
          onClick={() => {
            sessionStorage.setItem("cbb-sticky-dismissed", "1");
            setOpen(false);
          }}
          className="w-9 h-9 inline-flex items-center justify-center border border-white/15 bg-black/70 backdrop-blur-sm text-[#A39E99] hover:text-[#EAE0D5] hover:border-[#C5A059]/40"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
